import React, { useState, useEffect, useContext } from "react";
import { Button, IconButton } from "@mui/material";
import { ThemeProvider } from "@emotion/react";
import Input from "@mui/joy/Input";
import SearchIcon from "@mui/icons-material/Search";
import theme from "../../../themes/theme";
import AdminLayout from "../../../components/AdminDashboard/AdminLayout/AdminLayout";
import { useParams } from "react-router";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import TaskAltIcon from "@mui/icons-material/TaskAlt";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import axios from "axios";
import BASE_URL from "../../../config/api";
import { AppContext } from "../../../context/AppContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function AddCourseUser() {
  const [users, setUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [courseStudents, setCourseStudents] = useState([]);
  const [courseStudentIds, setCourseStudentIds] = useState([]);
  const [fetchUsersFlag, setFetchUsersFlag] = useState(true);
  const [numAdmins, setNumAdmins] = useState(0);
  const { token } = useContext(AppContext);
  const { id } = useParams();

  const fetchUsers = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/users`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setUsers(response.data);
      const numAdmins = response.data.filter(
        (student) => student.userRole === 1
      ).length;
      setNumAdmins(numAdmins);
    } catch (error) {
    } finally {
      setFetchUsersFlag(false);
    }
  };

  const fetchCourseStudents = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/courses/${id}/students`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setCourseStudents(response.data);

      const updatedCourseStudentIds = response.data.map(
        (courseStudent) => courseStudent.id
      );
      setCourseStudentIds(updatedCourseStudentIds);
    } catch (error) {}
  };

  useEffect(() => {
    if (token && fetchUsersFlag) {
      fetchUsers();
    }
  }, [token, fetchUsersFlag]);

  useEffect(() => {
    if (token) {
      fetchCourseStudents();
    }
  }, [token, id]);

  const handleAddClick = async (userId) => {
    try {
      await axios.post(
        `${BASE_URL}/courses/${id}/students`,
        { studentId: userId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      fetchCourseStudents();
      setFetchUsersFlag(true);
    } catch (error) {}
  };

  const changeUserRole = async (userId, userRole) => {
    try {
      if (token) {
        let endpoint;
        if (userRole === 0) {
          endpoint = `${BASE_URL}/users/${userId}/setAdmin`;
        } else if (userRole === 1) {
          endpoint = `${BASE_URL}/users/${userId}/removeAdmin`;
        }

        if (endpoint) {
          await axios.patch(
            endpoint,
            {},
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          toast.success("Role changed successfully");
          setFetchUsersFlag(true);
        }
      }
    } catch (error) {
      // console.log(error.response.data)
    }
  };

  const filteredStudents = users.filter(
    (user) =>
      (user.userRole === 0 || user.userRole === 1) &&
      `${user.name} ${user.surname}`
        .toLowerCase()
        .includes(searchQuery.toLowerCase())
  );

  return (
    <AdminLayout>
      <div className="users">
        <div className="users-header">
          <p className="title">All students</p>
          <div className="options">
            <div className="admins">
              All students: {users.length - numAdmins}
            </div>
            <div className="admins">
              Students enrolled: {courseStudents.length}
            </div>
            <div className="admins">Number of admins: {numAdmins}</div>
            <div className="search">
              <Input
                variant="soft"
                placeholder="Search students"
                sx={{ width: "150%" }}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <ThemeProvider theme={theme}>
                <Button variant="contained" sx={{ padding: "0px -2px" }}>
                  <SearchIcon />
                </Button>
              </ThemeProvider>
            </div>
          </div>
        </div>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Full Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Role</TableCell>
                <TableCell>Enrolled</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredStudents.map((user) => (
                <TableRow key={user._id}>
                  <TableCell>
                    {user.name} {user.surname}
                  </TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell>
                    {user.userRole === 0 ? "Student" : "Admin"}
                  </TableCell>
                  <TableCell>
                    {courseStudentIds.includes(user._id) ? (
                      <div style={{ color: "green" }}>
                        <TaskAltIcon />
                      </div>
                    ) : (
                      <IconButton
                        style={{ color: "#0E1937", marginLeft: "-5px" }}
                        onClick={() => handleAddClick(user._id)}
                      >
                        <AddCircleIcon />
                      </IconButton>
                    )}
                  </TableCell>
                  <TableCell>
                    <ThemeProvider theme={theme}>
                      <Button
                        variant="contained"
                        onClick={() => changeUserRole(user._id, user.userRole)}
                      >
                        Change role
                      </Button>
                    </ThemeProvider>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <ToastContainer></ToastContainer>
      </div>
    </AdminLayout>
  );
}
